<template lang="html">

 <section class="intro-xs">
      <div class="col-50 flex column nowrap justify-center align-center animated fadeInLeft">
        <div class="container-text">
          <h2 class="title title-52">{{$t('enlaces.textos.actualidad')}}</h2>
        </div>
      </div>
    </section>

</template>

<script lang="js">
  export default  {
    name: 'actualidad',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    }
}
</script>

<style scoped>
  .actualidad {

  }
</style>



// WEBPACK FOOTER //
// src/components/view-parts/intros/actualidad.vue